<template>
  <div class="wrapper1">
      <div class="nav flex">
          <div class="nav-item" 
          :class="years==item&&'active'" 
          v-for="(item, index) in yearList" 
          @click="years=item,findWords()"
          :key="index">{{item}}</div>
      </div>
      <div class="list">
        <div class="item flex fd-c ai-c" v-for="(item, index) in list" :key="index">
          <!-- <viewer :images="[item.pictures]"> 
                    <img
                          v-for="(src,index) in [item.pictures]"
                          :src="src"
                          class="listWOW fadeInDown"
                          data-wow-duration="0.4s"
                          data-wow-delay="0.5s" 
                          :key="index"
                        >
          </viewer> -->
          <img class="listWOW fadeInDown"
          data-wow-duration="0.4s"
          data-wow-delay="0.5s" 
          :src="item.pictures" 
          @click="picturesClick(index)" alt="">
          <div class="txt-box flex fd-c ai-c listWOW fadeInDown"
          data-wow-duration="0.6s"
          data-wow-delay="0.5s">
            <div class="txt" v-html="item.info"></div>
          </div>
        </div>
      </div>
      <van-icon v-show="show" @click="arrowClick('-')" name="arrow-left" />
      <van-image-preview ref="preview" :startPosition="startPosition" v-model="show" :images="imagePreviewList" @change="onChange">
        <template v-slot:index>{{ index + 1}}/{{imagePreviewList.length}}</template>
      </van-image-preview>
      <van-icon v-show="show" @click="arrowClick('+')" name="arrow" />
  </div>
</template>

<script>
import { findWords, workYears } from '../../../api'
import { ImagePreview } from 'vant';
import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from "v-viewer"
export default {
  components:{},
  props:{},
  data(){
    return {
        yearList: [],
        years:'',
        list: [],
        imagePreviewList: [],
        index: 0,
        startPosition: 0,
        show: false
    }
  },
  watch:{},
  computed:{},
  methods:{
    arrowClick(type) {
      if (type=='+') {
        this.index==this.imagePreviewList.length?this.$refs.preview.swipeTo(0):this.$refs.preview.swipeTo(this.index+1)
        
      } else {
        this.index==1?this.$refs.preview.swipeTo(this.imagePreviewList.length):this.$refs.preview.swipeTo(this.index-1)

      }
    },
    workYears() {
      workYears({
      }).then(res=>{
        var list = res.data.data.split(',')
        var date = new Date();
        this.years = list.length>0?list[0]:date.getFullYear()
        this.yearList = list
      })
    },
    findWords() {
      findWords({
        page: 1,
        limit: 100,
        years: this.years,
        equipment: 0
      }).then(res=>{
        var data = res.data.data.records
        var imagePreviewList = []
        for (var item of data) {
          imagePreviewList.push(item.pictures)
        }
        this.imagePreviewList = imagePreviewList
        this.list = res.data.data.records
        this.$nextTick(()=>{
          this.$wow('listWOW')
        })
      })
    },
    onChange(e) {
      console.log(e);
      this.index = e
    },
    picturesClick(index){
      // this.index = index + 1
      // this.show = true
      
      var ua = navigator.userAgent,
      isWindowsPhone = /(?:Windows Phone)/.test(ua),
      isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
      isPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isPc = !isPhone && !isAndroid && !isSymbian;
      console.log(isTablet);
      if (isTablet) {
          ImagePreview({
            images: this.imagePreviewList,
            startPosition: index,
          })
      } else {
        this.show = true
        this.index = index
        this.startPosition = index
        // setTimeout(()=>{
        //   this.$refs.preview.swipeTo(index)
        // },10)
        // const $viewer = viewerApi({
        //   options: {
        //     toolbar: true,
        //     initialViewIndex: index
        //   },
        //   images: this.imagePreviewList
        // })
      }
     
    }
  },
  created(){
    this.workYears()
    this.findWords()
  },
  mounted(){}
}
</script>
<style scoped>
.wrapper1{
  width: 900px;
  margin: 0 auto;
}
.wrapper1>>>.van-image-preview__overlay{
  background-color: #fff;
}
.nav {
  position: fixed;
  top: 0;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #fff;
  z-index: 99;
}
.nav .nav-item{
  font-size: 14px;
  font-family: KhmerSangamMN;
  font-weight: 400;
  color: #000000;
  line-height: 15px;
  cursor: pointer;
  margin-right: 30px;
}
.nav .active{
  color:rgba(0, 0, 255, 1);
}
.list {
  margin-top: 57px;
}
.list .item{
  margin-bottom: 138px;
}
.list img{
  max-width: 900px;
  height: auto;
  max-height: 750px;

  /* object-fit: contain; */
}
.list .txt-box{
  margin-top: 18px;
}
.list .txt>>>*{
  font-size: 14px;
  font-family: KhmerSangamMN;
  font-weight: 400;
  /* font-style: italic; */
  line-height: 18px;
  color: #000000;
}
.van-icon-arrow-left{
  position: fixed;
  top: calc(50vh - 25px);
  left: 30px;
  font-size: 50px;
  cursor: pointer;
  z-index: 10000;
}
.van-icon-arrow{
  position: fixed;
  top: calc(50vh - 25px);
  right: 30px;
  font-size: 50px;
  cursor: pointer;
  z-index: 10000;
}
</style>